/**
 * Whether a drag carries files, as opposed to text or a link dragged inside
 * the page. Only file drags may be intercepted — cancelling a text drag would
 * advertise the element as a drop target for something it cannot accept.
 */
export function isFileDrag(transfer: DataTransfer | null): boolean {
  if (transfer === null) return false;
  return Array.from(transfer.types).includes('Files');
}
